<style lang="scss">
  @use "../../components/shared/tab-body.scss";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_colors.scss"
    as colors;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils.scss"
    as utils;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_mixins.scss"
    as mixins;

  .notice {
    margin-top: utils.in_rem(8px);
    margin-bottom: utils.in_rem(32px);
    p {
      @include mixins.body2();
      a {
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
      }
    }
  }
</style>

<script>
  import InlineNotification from "@sourcewhale/shared/svelte-design-system/components/atoms/InlineNotification.svelte";
  import CustomTabs from "../../components/shared/CustomTabs.svelte";
  import Description from "../../components/shared/Description.svelte";
  import FieldsMapping from "../../components/shared/FieldsMapping.svelte";
  import TabContent from "../../components/shared/TabContent.svelte";
  import { integrationStore } from "../../stores";

  $: providerTitle = $integrationStore.getProviderTitle();
  $: learnMoreLink = $integrationStore.getLearnMoreLink("contactFields");

  $: description = {
    title: "Contact Fields",
    description: `Match SourceWhale contact fields to ${providerTitle} fields for accurate data mapping.`,
    learnMoreLink,
  };

  $: notice = `SourceWhale will automatically map these fields, so you don't need to adjust anything unless something doesn't appear correctly in ${providerTitle}. Before making changes, we recommend testing how contacts appear in ${providerTitle}.`;

  const syncKinds = $integrationStore.getSyncKinds();

  const tabItems =
    $integrationStore
      .getSyncAsSet()
      .map((kind, index) => ({
        label: (
          $integrationStore.getSyncAsLabelMap()[kind] || kind
        ).toUpperCase(),
        slot: `tab${index}`,
        kind,
      }))
      .sort(
        (a, b) => syncKinds.includes(b.kind) - syncKinds.includes(a.kind)
      ) || [];

  let currentType;

  $: hasFields = $integrationStore.getFields($currentType)?.length > 0;

  const learnTestLink =
    "https://help.sourcewhale.app/en/articles/10710259-how-to-push-a-test-contact";
</script>

<div class="contact-fields tab-body">
  <Description {...description} />

  <div class="notice">
    <InlineNotification>
      <p>
        {notice}
        <a href={learnTestLink} target="_blank"
          >Learn how to push a test contact.</a
        >
      </p>
    </InlineNotification>
  </div>

  <CustomTabs {tabItems} bind:currentType />
  <TabContent
    hasData={hasFields}
    tabCount={tabItems.length}
    emptyMessage="No field mappings available for this type."
  >
    <FieldsMapping syncAs={$currentType} />
  </TabContent>
</div>
